import React from 'react';
import GenerationDetail from 'components/Tvendo/Inventory/Operations/TakingInventory/Generation';

export default function () {
  return <GenerationDetail />;
}
